import { render, staticRenderFns } from "./ClientService.vue?vue&type=template&id=19d1fa1c&scoped=true&"
import script from "./ClientService.vue?vue&type=script&lang=js&"
export * from "./ClientService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1fa1c",
  null
  
)

export default component.exports